import { render, staticRenderFns } from "./QuoProprtional.vue?vue&type=template&id=8363b78c&scoped=true&"
import script from "./QuoProprtional.vue?vue&type=script&lang=js&"
export * from "./QuoProprtional.vue?vue&type=script&lang=js&"
import style0 from "./QuoProprtional.vue?vue&type=style&index=0&id=8363b78c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363b78c",
  null
  
)

export default component.exports